module.exports = __webpack_public_path__ + "img/icon_yellow_medal.db096eb5.png";